module.exports = __webpack_public_path__ + "img/18_22.6c3212ea.png";